import { render, staticRenderFns } from "./bar-chart.vue?vue&type=template&id=967c577c&scoped=true&"
import script from "./bar-chart.vue?vue&type=script&lang=ts&"
export * from "./bar-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967c577c",
  null
  
)

export default component.exports